// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1h-E-","card":"Cards_card__2eFcr","infected":"Cards_infected__3sGGH","recovered":"Cards_recovered__171TY","deaths":"Cards_deaths__33d0B"};